import React, { createContext, useContext, useEffect } from 'react';
import { useGameStore, selectIsInitialized } from './gameStore';

// Create context for the store
const GameStoreContext = createContext<typeof useGameStore | null>(null);

// Custom hook to use the store
export function useStore() {
  const store = useContext(GameStoreContext);
  if (!store) {
    throw new Error("useStore must be used within a GameStoreProvider");
  }
  return store;
}

// Compatibility hook for components that used useStoresInitialized
export function useStoresInitialized() {
  return useGameStore(selectIsInitialized);
}

interface GameStoreProviderProps {
  children: React.ReactNode;
}

export function GameStoreProvider({ children }: GameStoreProviderProps) {
  useEffect(() => {
    // Initialize the store when provider mounts
    const initialize = useGameStore.getState().initialize;
    initialize();

    // Cleanup on unmount
    return () => {
      const reset = useGameStore.getState().reset;
      reset();
    };
  }, []); // Empty dependency array - only run once on mount

  return (
    <GameStoreContext.Provider value={useGameStore}>
      {children}
    </GameStoreContext.Provider>
  );
}
